module.exports = __webpack_public_path__ + "static/media/2096Ambrosia_colored.1b1fca4a.jpg";